import { BaseCommand } from '../ICommand';
import { getNodeMutationManager } from '../mutations/NodeMutationManager';
import type { Edge } from '../../models/scene';
import { useDiagramStore } from '../../../stores/diagramStore';
import { validateShapeLimitOrPromptUpgrade } from '../../../utils/shapeLimitUtils';

export class DuplicateEdgeCommand extends BaseCommand {
  private sourceEdgeId: string;
  private newEdgeId: string | null = null;

  constructor(sourceEdgeId: string) {
    super('Duplicate Edge', `Duplicate edge ${sourceEdgeId}`);
    this.sourceEdgeId = sourceEdgeId;
  }

  execute(): void {
    // Check shape limits
    const store = useDiagramStore.getState();
    if (!validateShapeLimitOrPromptUpgrade(store)) {
      return;
    }
    
    const mutationManager = getNodeMutationManager();
    const source = mutationManager.getEdge(this.sourceEdgeId);
    if (!source) return;
    const id = `edge-${Date.now()}-${Math.random().toString(36).slice(2)}`;
    this.newEdgeId = id;
    const clone: Edge = {
      id,
      type: source.type,
      from: source.from,
      to: source.to,
      attrs: { ...(source.attrs || {}) }
    } as any;
    (clone as any).fromAnchor = (source as any).fromAnchor;
    (clone as any).toAnchor = (source as any).toAnchor;
    (clone as any).fromOffset = (source as any).fromOffset;
    (clone as any).toOffset = (source as any).toOffset;
    (clone as any).fromAnchorLocked = (source as any).fromAnchorLocked;
    (clone as any).toAnchorLocked = (source as any).toAnchorLocked;
    mutationManager.addEdge(clone);
  }

  undo(): void {
    if (!this.newEdgeId) return;
    const mutationManager = getNodeMutationManager();
    mutationManager.deleteEdge(this.newEdgeId);
  }
}
